import Highway from '@dogstudio/highway'
import loadComponents from './loadComponents'

export default class DefaultRenderer extends Highway.Renderer {
  onEnter() {
    loadComponents(this.wrap.lastElementChild)
  }
}
